<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >作业活动危险源编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="作业活动危险源详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <JobForm :taskId="formData.id" :disabled="formProps.editType === 'read'" />
          </el-collapse-item>
          <el-collapse-item title="危险源辨识" name="risk">
            <JobIdentify
              :disabled="formProps.editType === 'read'"
              :taskId="formData.id"
              ref="jobIdentify"
            />
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm('submit')" :loading="loading"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="submitForm('save')"
          :loading="loading"
          v-if="formProps.editType !== 'submit'"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { JobSourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import JobForm from '../business/JobForm'
// import ControlMeasure from '../business/ControlMeasure'
import JobIdentify from '../business/JobIdentify'

const jobSourcesDangerIdentifyApi = new JobSourcesDangerIdentifyApi()

export default {
  name: 'identify-job-form',
  components: {
    JobForm,
    JobIdentify,
    // ControlMeasure
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '新增作业活动辨识',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      list: [],
      rules: {},
      tableFormData: {},
      tableData: [{ id: new Date().getTime() }],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk'],
    }
  },
  watch: {},
  created() {},
  mounted() {},

  methods: {
    tableChange(row, value, filed) {
      row[filed] = value
    },
    async submitForm(type) {
      // submit
      if (this.$refs.jobIdentify.validate()) {
        // 没有辨识数据不让提交
        const tableData = this.$refs.jobIdentify.tableData
        if (type === 'submit' && !(tableData && tableData.length)) {
          this.$message.warning({
            showClose: true,
            message: '请先添加辨识后提交！',
          })
          return
        }
        const data = {
          body: {
            sourcesDangerRecognitionPlanTaskId: this.formData.id,
            data: this.$refs.jobIdentify.tableData,
          },
        }
        this.loading = true
        const [err, res] =
          type === 'save'
            ? await jobSourcesDangerIdentifyApi.save(data)
            : await jobSourcesDangerIdentifyApi.submitSave(data)
        if (!err) {
          this.$emit('refreshList')
          this.$emit('cancel')
        }
        this.loading = false
      }
    },
    createRow() {
      this.tableData.push({
        id: new Date().getTime(),
      })
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        return item.id !== id
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
